import styled from 'styled-components';

// Simple flexbox grid for use in site
// Any number of columns can be used, column will default to size 1 if size prop not passed
// Size determines how column width is distributed if distribution is not to be equal

// TODO:
// 1. could add a collapse prop that will hide columns on specific breakpoints
// 2. could add some breakpoints to automatically breakout to single columns on mobile / tablet
// 3. could add breakpoint specific sizes, eg. mobile=12, tablet=6

export const FlexRow = styled.div`
  width: 100%;
  display: flex;
`;

export const FlexCol = styled.div`
  flex: ${({ $flexCol = 1 }) => `${$flexCol} 0 0%`};
`;
